<template>
    <div v-if="loaded">
        <div class="inapp-hide" style="height: 5vh;"></div>
        <!--<Riassunto/>-->
        <div class="row py-3 py-md-6 text-dark border-bottom mb-4">
            <div class="col-md-6 pt-lg-5 text-dark text-shadow">
                <div class="text-dark m-0 firstchoice-header font-weight-normal">Iscriviti alla</div>
                <div class="mb-2 firstchoice-sub-header font-weight-bold h1">{{race_name}}</div>
                <div class="mb-2 h1 font-weight-bold">{{titolo}}</div>
                <div class="font-weight-normal firstchoice-header-text mb-md-2 mb-1 mt-3 mt-lg-4 mt-md-2 text-uppercase" style="white-space: pre-wrap">{{sottotitolo}}</div>
                <div class="font-weight-normal firstchoice-header-text text-uppercase mb-5"><span>La tua iscrizione è una donazione a sostegno dei progetti di Susan G. Komen italia</span> </div>
                <!-- <span class="d-block">di Susan G. Komen italia</span></div> -->
            </div>
            <div class="col-md-6 pt-3 pt-md-0 text-right">
                <img :src="race_logo" class="img-fluid firstchoice-race-logo">
            </div>
        </div>
        <div class="race-app-header inapp-show"></div>
        <div class="v-step step active mt-0 pt-0">
            <div class="v-section-row">
                <div class="v-section-col col-12">
                    <a @click="iscrizioneSemplice">
                        <div class="v-section-col-img"><img src="/static/svg/runner-simple.svg" height="120"></div>
                        <div class="v-section-col-txt">Iscriviti</div>
                        <div class="v-section-col-txt button-link"><span></span></div>
                    </a>
                </div>
                <div class="v-section-col col-md-6">
                    <a @click="selezioneTeam">
                        <div class="v-section-col-img"><img src="/static/svg/runner-team-add.svg" height="120"></div>
                        <div class="v-section-col-txt">Iscriviti ad una squadra <br> già esistente</div>
                        <div class="v-section-col-txt button-link"><span></span></div>
                    </a>
                </div>
                <div class="v-section-col col-md-6">
                    <a @click="creazioneTeam">
                        <div class="v-section-col-img"><img src="/static/svg/runner-team.svg" height="120"></div>
                        <div class="v-section-col-txt">Crea la tua <br> squadra</div>
                        <div class="v-section-col-txt button-link"><span></span></div>
                    </a>
                </div>
                <!-- <div class="v-section-col col-md-6">
                    <a @click="sostieniUnaSquadra">
                        <div class="v-section-col-img"><img src="/static/svg/runner-support-team.svg" height="120"></div>
                        <div class="v-section-col-txt">Sostieni <br>una Squadra</div>
                        <div class="v-section-col-txt button-link"><span></span></div>
                    </a>
                </div> -->
                <div class="v-section-col col-12" >
                    <a @click="regalaUnIscrizione">
                        <div class="v-section-col-img"><img src="/static/svg/runner-gift.svg" height="120"></div>
                        <div class="v-section-col-txt">Regala una<br>iscrizione</div>
                        <div class="v-section-col-txt button-link"><span></span></div>
                    </a>
                </div>

            </div>
        </div>
        <div class="text-center pb-8">
            <div v-if="partner_principale" class="text-uppercase small pb-2">Partner</div>
            <div v-if="partner_principale" class="d-block pb-5 partner">
                <img :src=partner_principale height="60" class="img-fluid">
            </div>

            <!--<div v-if="partner_secondari" class="text-uppercase small pb-2">Local Major Partner</div>-->
            <div v-if="partner_secondari" class="d-block pb-5 partner">
                <img :src=partner_secondari height="40">
            </div>

            <!--<div v-if="thanksto" class="text-uppercase small pb-2">Thanks To</div>-->
            <div v-if="thanksto" class="d-block pb-5 partner">
                <img :src=thanksto height="40">
            </div>
        </div>
    </div>
</template>

<script>
    import BaseForm from "../BaseForm";
    // import Riassunto from "./Riassunto";

    export default {
        name: "FirstChoice",
        extends: BaseForm,
        // components: {Riassunto},
        data: function () {
            return {
                scelta: null,
                loaded: false,
                data_race: new Date()
            }
        }, methods: {
            submit: function () {
                this.$store.dispatch('choose_path', this.scelta)
                if (this.scelta === 'iscrizione-semplice')
                    this.$store.commit('team', null)
                    this.goTo('inserimento-dati')
                if (this.scelta === 'creazione-team')
                    this.goTo('creazione-team')
                if (this.scelta === 'iscrizione-a-team')
                    this.goTo('selezione-team')
                if (this.scelta === 'sostieni-squadra')
                    this.goTo('sostieni-squadra')
                 if (this.scelta === 'regala-iscrizione')
                    this.goTo('regala-iscrizione')
            }, creazioneTeam() {
                this.scelta = 'creazione-team'
                this.submit()
            }, selezioneTeam() {
                this.scelta = 'iscrizione-a-team'
                this.submit()
            }, iscrizioneSemplice() {
                this.scelta = 'iscrizione-semplice'
                this.submit()
            }, sostieniUnaSquadra() {
                this.scelta = 'sostieni-squadra'
                this.submit()
            },regalaUnIscrizione() {
                this.scelta = 'regala-iscrizione'
                this.submit()
            }, toTop() {
                return true
            }
        }, mounted() {
            // Verifico se mi ha chiesto il join ad un team
            setTimeout(() => {
                if (this.$store.getters.race_italia)
                    this.goTo('race-italia')

                let team = this.$store.getters.join_request
                if (team !== null) {
                    this.$store.commit('team', team)
                    if (team.donate > 0) {
                        this.$store.commit('regalo', true)
                    }
                    this.goTo('inserimento-dati')
                }
                this.loaded = true
            },100)

        },computed: {
            race_logo() {
                return this.$store.getters.race_logo
            }, titolo() {
                return this.$store.getters.titolo_iniziale
            }, sottotitolo() {
                return this.$store.getters.sottotitolo_iniziale
            }
        }
    }
</script>